export default __webpack_public_path__ + "static/media/signout.d716fe56.svg";